import { render, staticRenderFns } from "./RC_taskmana.vue?vue&type=template&id=0441cfae&scoped=true"
import script from "./RC_taskmana.vue?vue&type=script&lang=js"
export * from "./RC_taskmana.vue?vue&type=script&lang=js"
import style0 from "./RC_taskmana.vue?vue&type=style&index=0&id=0441cfae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0441cfae",
  null
  
)

export default component.exports